import { useFormContext, useWatch } from "react-hook-form";
import { OperatorForm } from "./operator.schema";
import { Switch } from "@/src/components/ui/switch";
import { Label } from "@/src/components/ui/label";
import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { Textarea } from "@/src/components/ui/textarea";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export function GoodToKnow() {
  const goodToKnowType = useWatch<OperatorForm, "goodToKnow.type">({
    name: "goodToKnow.type",
  });
  const { setValue: setType } = useFormContext<OperatorForm>();

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ block: "start" });
      }
    }
  }, [location]);

  return (
    <div id="good-to-know" className="flex flex-col justify-stretch gap-4">
      <h3 className="text-lg font-semibold">Good to know</h3>
      <div className="flex items-center space-x-2">
        <Switch
          checked={goodToKnowType === "charter-dependent"}
          onCheckedChange={(checked) => {
            setType("goodToKnow.type", checked ? "charter-dependent" : "simple");
          }}
          id="operators.good-to-know.type"
        />
        <Label htmlFor="operators.good-to-know.type">Good to know</Label>
      </div>
      {goodToKnowType === "simple" && (
        <FormField<OperatorForm, "goodToKnow.simple">
          name="goodToKnow.simple"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Good to know</FormLabel>
              <FormControl>
                <Textarea rows={6} {...field} />
              </FormControl>
            </FormItem>
          )}
        />
      )}
      {goodToKnowType === "charter-dependent" && (
        <div className="flex flex-row flex-wrap gap-4">
          <FormField<OperatorForm, "goodToKnow.bareboat">
            name="goodToKnow.bareboat"
            render={({ field }) => (
              <FormItem className="min-w-full sm:min-w-[328px] flex-1">
                <FormLabel>Bareboat</FormLabel>
                <FormControl>
                  <Textarea rows={6} {...field} />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField<OperatorForm, "goodToKnow.skippered">
            name="goodToKnow.skippered"
            render={({ field }) => (
              <FormItem className="min-w-full sm:min-w-[328px] flex-1">
                <FormLabel>Skippered</FormLabel>
                <FormControl>
                  <Textarea rows={6} {...field} />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField<OperatorForm, "goodToKnow.crewed">
            name="goodToKnow.crewed"
            render={({ field }) => (
              <FormItem className="min-w-full sm:min-w-[328px] flex-1">
                <FormLabel>Crewed</FormLabel>
                <FormControl>
                  <Textarea rows={6} {...field} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      )}
    </div>
  );
}
